import { render, staticRenderFns } from "./SystemSection.vue?vue&type=template&id=5f159bac&scoped=true&"
import script from "./SystemSection.vue?vue&type=script&lang=ts&"
export * from "./SystemSection.vue?vue&type=script&lang=ts&"
import style0 from "./SystemSection.vue?vue&type=style&index=0&id=5f159bac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f159bac",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCImage: require('/opt/build/repo/apps/shop/components/FCImage.vue').default,FCSwiper: require('/opt/build/repo/apps/shop/components/FCSwiper.vue').default})
